import React, { createContext, useContext } from 'react'

type Theme = 'dark' | 'light'

const ThemeContext = createContext<{ theme: Theme }>({ theme: 'dark' })

export const useTheme = () => {
  return useContext(ThemeContext)
}

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeContext.Provider value={{ theme: 'dark' }}>
      {children}
    </ThemeContext.Provider>
  )
}